module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    attrs: {
      "id": "table"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.realized), function(points, index) {
    return _c('tr', [_c('td', [_vm._v("\n        " + _vm._s(("Day " + (index + 1))) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(points) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(_vm.remaining[index]) + "\n      ")])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Day")]), _vm._v(" "), _c('th', [_vm._v("Realized")]), _vm._v(" "), _c('th', [_vm._v("Remaining")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05e4beca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sprint/SprintList.vue
// module id = 540
// module chunks = 1